// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const ContractSkeletonComponentContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  width: 100%;
  position: absolute;
  left: 0;
  padding: 0 ${convertPxsToRems({ pixels: 120, base: 16 })};
`;

ContractSkeletonComponentContainer.displayName = 'ContractSkeletonComponentContainer';

const ContractPDFFinancialDataContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  width: 100%;
  justify-content: space-between;
`;

ContractPDFFinancialDataContainer.displayName = 'ContractPDFFinancialDataContainer';

const PDFConsentsSkeletonContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  width: 100%;
  height: auto;
  justify-content: space-between;
`;

PDFConsentsSkeletonContainer.displayName = 'PDFConsentsSkeletonContainer';

const FinancialDataLineSkeleton = styled.section`
  display: flex;
  width: auto;
  justify-content: space-between;
`;

FinancialDataLineSkeleton.displayName = 'FinancialDataLineSkeleton';

const FinancialDataSkeleton = styled.section`
  display: flex;
  width: 100%;
  gap: ${FoundationsCobrandedRegularTheme.spacing_100};
  flex-direction: column;
`;

FinancialDataSkeleton.displayName = 'FinancialDataSkeleton';

export {
  FinancialDataSkeleton,
  FinancialDataLineSkeleton,
  PDFConsentsSkeletonContainer,
  ContractPDFFinancialDataContainer,
  ContractSkeletonComponentContainer,
};
